import { ticks } from './config';

export interface TargetDef {
  maxHp: number;
  /** Static collision circle — players cannot walk through the pole. */
  bodyRadius: number;
  hurtRadius: number;
  respawnTicks: number;
  /** Left alone this long, it is whole again (the range's dummies, ADR-0100). */
  healTicks: number;
}

export const SCARECROW: TargetDef = {
  maxHp: 120,
  bodyRadius: 4,
  hurtRadius: 7,
  respawnTicks: ticks(3),
  healTicks: ticks(4),
};
